import { render, staticRenderFns } from "./draggableDynamicTable.vue?vue&type=template&id=16e61e91"
import script from "./draggableDynamicTable.vue?vue&type=script&lang=js"
export * from "./draggableDynamicTable.vue?vue&type=script&lang=js"
import style0 from "./draggableDynamicTable.vue?vue&type=style&index=0&id=16e61e91&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports